import React, { FC, ReactNode, useState } from 'react';
import { ItemRequestContext } from './context';
import { RequestType } from 'models/item-request.model';

const ItemRequestProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [itemRequestToEdit, setItemRequestToEdit] = useState<RequestType | any>(null);
  return (
    <ItemRequestContext.Provider
      value={{
        itemRequestToEdit,
        setItemRequestToEdit
      }}>
      {children}
    </ItemRequestContext.Provider>
  );
};

export default ItemRequestProvider;
